import React, { useState, useEffect } from 'react';
import axios from 'axios';
import qs from 'qs';
import '../Style.css';
import LogoutButton from './LogoutButton';

const TicketForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        payment_method: 'Cash',
        ticket_cat: 'Student',
        amount: 500,
        reference: '',
        order_id: 1000,
        upgrade_from: '',
        upgrade_to: ''
    });
    // const [smsResponse, setSmsResponse] = useState('');

    const ticketPrices = {
        Student: 500,
        General: 999,
        Premium: 6000,
        Diamond: 11000,
        Infinite: 25000,
        Stall: 0.0,
        Sponsor: 0.0,        
        Media: 0.0,
        VIP: 0.0,
        Delegate: 0.0
    };

    // Fetch last order_id
    useEffect(() => {
        axios.get('https://register.tjdstore.in/api/get_last_order_id.php')
            .then(response => {
                const lastOrderId = response.data.order_id;
                const newOrderId = parseInt(lastOrderId, 10) + 1;
                setFormData(prev => ({
                    ...prev,
                    order_id: newOrderId
                }));
            })
            .catch(error => {
                console.error('Error fetching last order ID:', error);
            });
    }, []);

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'ticket_cat') {
            // If "Upgrade" is selected, don't overwrite the amount yet
            setFormData({
                ...formData,
                ticket_cat: value,
                amount: value === 'Upgrade' ? 0 : ticketPrices[value]
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };


const sendWhatsapp = async (order_id) => {
    try {
        const res = await fetch('https://register.tjdstore.in/api/send_whatsapp.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                order_id: order_id
            }),
        });

        const data = await res.text();
        console.log("WhatsApp:", data);

    } catch (error) {
        console.error('Error sending WhatsApp:', error);
    }
};


    // Send SMS
    // const sendSms = async (mobile) => {
    //     try {
    //         const res = await fetch('https://register.tjdstore.in/api/send_whatsapp.php', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/x-www-form-urlencoded',
    //             },
    //             body: new URLSearchParams({
    //                 order_id: formData.order_id,
    //                 phone_number: mobile,
    //             }),
    //         });
    //         const data = await res.text();
    //         setSmsResponse(data);
    //     } catch (error) {
    //         console.error('Error sending SMS:', error);
    //         setSmsResponse('Error sending SMS');
    //     }
    // };

    // Submit form
    const handleSubmit = (e) => {
        e.preventDefault();

        axios.post('https://register.tjdstore.in/api/submit_ticket.php', qs.stringify(formData), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            // Send email
            axios.post('https://register.tjdstore.in/api/ticket_send_mail.php', qs.stringify({
                ...formData
            }), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            })
            .then(mailResponse => {
                console.log('Mail sent successfully:', mailResponse.data);
            })
            .catch(mailError => {
                console.error('Error sending email:', mailError.response ? mailError.response.data : mailError.message);
            });

            // sendSms(formData.mobile);
            sendWhatsapp(formData.order_id);   // ✅ ADD THIS LINE

            alert('Form submitted successfully!');

           
            setFormData({
                order_id: '',
                name: '',
                email: '',
                mobile: '',
                payment_method: 'Cash',
                ticket_cat: 'Student',
                amount: 500,
                reference: '',
                upgrade_from: '',
                upgrade_to: ''
            });
        })
        .catch(error => {
            console.error('Error:', error.response ? error.response.data : error.message);
            alert('An error occurred while submitting the form.');
        });
    };

    return (
        <div className="container topic">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card mt-5">
                        <div className="card-body">
                            <LogoutButton />
                            <h2 className="center">TICKET BOOKING</h2>
                            <form onSubmit={handleSubmit}>

                                <div className="mb-3">
                                    <label>Order ID:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="order_id"
                                        value={formData.order_id}
                                        readOnly
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Name:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Email:</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Mobile:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Ticket Type Selection */}
                                <div className="mb-3">
                                    <label>Ticket Category:</label>
                                    <select
                                        name="ticket_cat"
                                        className="form-select"
                                        value={formData.ticket_cat}
                                        onChange={handleChange}
                                    >
                                        <option value="Student">Student</option>
                                        <option value="General">General</option>
                                        <option value="Premium">Premium</option>
                                        <option value="Diamond">Diamond</option>
                                        <option value="Infinite">Infinite</option>
                                        <option value="Stall">Stall</option>
                                        <option value="Sponsor">Sponsor</option>                                        
                                        <option value="VIP">VIP</option>
                                        <option value="Media">Media</option>
                                        <option value="Delegate">Delegate</option>
                                        <option value="Upgrade">Upgrade</option>
                                    </select>
                                </div>

                                {/* Upgrade Fields */}
                                {formData.ticket_cat === 'Upgrade' && (
                                    <>
                                        <div className="mb-3">
                                            <label>Upgrade From:</label>
                                            <select
                                                name="upgrade_from"
                                                className="form-select"
                                                value={formData.upgrade_from}
                                                onChange={(e) => {
                                                    const newFrom = e.target.value;
                                                    const diff = formData.upgrade_to
                                                        ? ticketPrices[formData.upgrade_to] - ticketPrices[newFrom]
                                                        : 0;
                                                    setFormData({
                                                        ...formData,
                                                        upgrade_from: newFrom,
                                                        amount: diff > 0 ? diff : 0
                                                    });
                                                }}
                                            >
                                                <option value="">Select</option>
                                                {Object.keys(ticketPrices).map((type) => (
                                                    <option key={type} value={type}>{type}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="mb-3">
                                            <label>Upgrade To:</label>
                                            <select
                                                name="upgrade_to"
                                                className="form-select"
                                                value={formData.upgrade_to}
                                                onChange={(e) => {
                                                    const newTo = e.target.value;
                                                    const diff = formData.upgrade_from
                                                        ? ticketPrices[newTo] - ticketPrices[formData.upgrade_from]
                                                        : 0;
                                                    setFormData({
                                                        ...formData,
                                                        upgrade_to: newTo,
                                                        amount: diff > 0 ? diff : 0
                                                    });
                                                }}
                                            >
                                                <option value="">Select</option>
                                                {Object.keys(ticketPrices).map((type) => (
                                                    <option key={type} value={type}>{type}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </>
                                )}

                                {/* Reference field for VIP or Delegate */}
                                {(formData.ticket_cat === 'VIP' || formData.ticket_cat === 'Delegate' || formData.ticket_cat === 'Sponsor') && (
                                    <div className="mb-3">
                                        <label>Reference:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="reference"
                                            value={formData.reference}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                )}

                                <div className="mb-3">
                                    <label>Amount:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="amount"
                                        value={formData.amount}
                                        readOnly
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Payment Method:</label>
                                    <select
                                        className="form-select"
                                        name="payment_method"
                                        value={formData.payment_method}
                                        onChange={handleChange}
                                    >
                                        <option value="Cash">Cash</option>
                                        <option value="Online">Online</option>
                                        <option value="None">None</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <button className="btn btn-info" type="submit"><strong>SUBMIT</strong></button>
                                </div>
                            </form>

                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TicketForm;
